module.exports = __webpack_public_path__ + "static/group-two-591a78701351c603f9271eed1c2729a9.jpg";